import { globalState } from '@codeleap/store'
import { LocalStorageKeys } from '../../app/constants'

/**
 * Debug-only override for the gating in `isAnalyticsEnabled()`, mirroring mobile's.
 *
 * With it on, every guard is short-circuited — build environment, selected server,
 * Codeleap and test addresses, impersonation — and the client reports against the
 * development Segment source whatever the build would otherwise have chosen. With it off,
 * the guards apply as written.
 *
 * It exists because the two are otherwise inseparable: `isProduction()` reads the server
 * the test panel selects, and that same value decides which API the app talks to. Asking
 * QA to turn analytics on meant asking them to point the app at the production backend and
 * write real data there. This decouples the two.
 *
 * Persisted, because applying it reloads the page: the write key is resolved once, when
 * the SDK loads, so a client that already loaded against the production key cannot be
 * repointed in place.
 */
const store = globalState({ bypass: false }, { persistKey: LocalStorageKeys.ANALYTICS_BYPASS })

export const analyticsDebug = {
  isBypassEnabled: () => store.get()?.bypass ?? false,
  setBypass: (to: boolean) => store.set({ bypass: to }),
  use: () => store.use(s => s?.bypass ?? false)
}
